export interface TaxRegisterEntry {
  id: string;
  tenantId: string;
  countryCode: string;
  registerType: "sales" | "purchases";
  fiscalPeriod: string;
  documentTypeCode: string;
  documentNumber: string;
  documentDate: string | null;
  receptionDate: string | null;
  partyTaxId: string | null;
  partyName: string | null;
  exemptAmount: number | null;
  netAmount: number | null;
  taxAmount: number | null;
  totalAmount: number | null;
  accountingStatus: "pending" | "draft" | "posted";
  journalEntryId: string | null;
  countryMetadata: Record<string, unknown>;
  syncedAt: string;
}

export interface TaxRegisterTotals {
  count: number;
  exemptAmount: number;
  netAmount: number;
  taxAmount: number;
  totalAmount: number;
}

export interface TaxRegisterSyncLog {
  id: string;
  fiscalPeriod: string;
  status: "pending" | "in_progress" | "completed" | "failed";
  salesCount: number | null;
  purchasesCount: number | null;
  errorMessage: string | null;
  completedAt: string | null;
}

export const DTE_TYPE_LABELS: Record<string, string> = {
  "33": "Factura",
  "34": "Exenta",
  "46": "Factura Compra",
  "52": "Guia Despacho",
  "56": "N. Debito",
  "61": "N. Credito",
};

export const ACCOUNTING_STATUS_LABELS: Record<string, string> = {
  pending: "Pendiente",
  draft: "Borrador",
  posted: "Contabilizado",
};
